<template>
  <p class="reset-survey">
    <a href="#">
      <span @click="reset()">
        <slot>Reset survey</slot>
      </span>
    </a>
    <slot name="additional-info">
      - the date will changed to today and invites resent
    </slot>
  </p>
</template>
<script>
import { INSTANCE_TYPE } from "~/Components/constants";
import {
  setInstanceAsSubmitted as setThreeSixtyInstanceAsSubmitted,
  setReviewerEmailAsSent as setThreeSixtyReviewerAsSent,
  setInstanceAsActive as setThreeSixtyInstanceAsActive,
} from "~/Scripts/resources/threeSixtyResource";
import {
  setInstanceAsSubmitted as setEngageInstanceAsSubmitted,
  setReviewerEmailAsSent as setEngageReviewerAsSent,
  setInstanceAsActive as setEngageInstanceAsActive,
} from "~/Scripts/resources/engageResource";
import {
  setInstanceAsSubmitted as setTeamInstanceAsSubmitted,
  setMemberEmailAsSent as setTeamMemberAsSent,
  setInstanceAsActive as setTeamInstanceAsActive,
} from "~/Scripts/resources/teamResource";

export default {
  name: "ResetSurvey",
  props: {
    instanceId: {
      type: String,
      required: true,
    },
    instanceType: {
      type: String,
      required: true,
      validator: val => [
        INSTANCE_TYPE.THREE_SIXTY,
        INSTANCE_TYPE.PERSONA,
        INSTANCE_TYPE.STYLE,
        INSTANCE_TYPE.SURVEY,
        INSTANCE_TYPE.ENGAGE,
        INSTANCE_TYPE.TEAM,
      ].includes( val.toUpperCase() ),
    },
    instanceReviewers: {
      type: Array,
      default: () => [],
      validator ( val ) {
        const keys = ["reviewerId"];
        if ( val.length <= 0 ) {
          return true;
        }
        return val.every( obj => {
          const x = keys.every( key => Object.prototype.hasOwnProperty.call( obj, key ) );
          return x;
        } );
      },
    },
  },
  computed: {
    setAsActive () {
      switch ( this.instanceType ) {
        case INSTANCE_TYPE.ENGAGE: {
          return setEngageInstanceAsActive;
        }
        case INSTANCE_TYPE.THREE_SIXTY: {
          return setThreeSixtyInstanceAsActive;
        }
        case INSTANCE_TYPE.TEAM: {
          return setTeamInstanceAsActive;
        }
        default: {
          throw new Error( "setAsActive not defined" );
        }
      }
    },
    setEmailAsSent () {
      switch ( this.instanceType ) {
        case INSTANCE_TYPE.ENGAGE: {
          return setEngageReviewerAsSent;
        }
        case INSTANCE_TYPE.THREE_SIXTY: {
          return setThreeSixtyReviewerAsSent;
        }
        case INSTANCE_TYPE.TEAM: {
          return setTeamMemberAsSent;
        }
        default: {
          throw new Error( "setEmailAsSent not defined" );
        }
      }
    },
    setInstanceAsSubmitted () {
      switch ( this.instanceType ) {
        case INSTANCE_TYPE.ENGAGE: {
          return setEngageInstanceAsSubmitted;
        }
        case INSTANCE_TYPE.THREE_SIXTY: {
          return setThreeSixtyInstanceAsSubmitted;
        }
        case INSTANCE_TYPE.TEAM: {
          return setTeamInstanceAsSubmitted;
        }
        default: {
          throw new Error( "setInstanceAsSubmitted not defined" );
        }
      }
    },
  },
  methods: {
    hasProperty ( obj, key ) {
      return Object.prototype.hasOwnProperty.call( obj, key );
    },
    isNullOrEmpty ( val ) {
      return val == null || val === "";
    },
    makeToast ( body, title, variant = "info", append = false ) {
      this.$bvToast.toast( body, {
        title,
        variant,
        solid: true,
        appendToast: append,
      } );
    },
    reset () {
      this.$bvModal.msgBoxConfirm( "Are you sure?" ).then( async val => {
        if ( val ) {
          // resend emails
          try {
            await this.distirbuteEmails();
          } catch ( err ) {
            console.error( err );
            this.makeToast(
              "We were unable to send emails to some or all of your reviewers.",
              "Something went wrong",
              "warning",
            );
          }
          // submit instance
          try {
            await this.setInstanceAsActive();
            await this.submitInstance();
            window.location.reload();
          } catch ( err ) {
            console.error( err );
            this.makeToast(
              "Something went wrong. Please, try again or contact us.",
              "Failed to reset survey",
              "danger",
              true,
            );
          }
        }
      } );
    },
    distirbuteEmails () {
      return this.instanceReviewers.reduce( async ( promise, r ) => {
        // wait for the previous async function to finish.
        await promise;
        const { reviewerId } = r;

        // eslint-disable-next-line
        const { data } = await this.setEmailAsSent({
          reviewerId,
        } );
        console.info( data );
      }, Promise.resolve() );
    },
    setInstanceAsActive () {
      return new Promise( ( resolve, reject ) => {
        this.setAsActive( { instanceId: this.instanceId } )
          .then( ( { data, status } ) => {
            if ( status === 200 && data ) {
              resolve( data );
            } else {
              reject();
            }
          } )
          .catch( err => {
            reject( err );
          } );
      } );
    },
    submitInstance () {
      return new Promise( ( resolve, reject ) => {
        this.setInstanceAsSubmitted( { instanceId: this.instanceId } )
          .then( ( { data, status } ) => {
            if ( status === 200 && data ) {
              resolve( data );
            } else {
              reject();
            }
          } )
          .catch( err => {
            reject( err );
          } );
      } );
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../Styles/utils/index.less";

.reset-survey {
  > a {
    color: @blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
